import { render, staticRenderFns } from "./DepositStatusTag.vue?vue&type=template&id=d82f3e4c&"
import script from "./DepositStatusTag.vue?vue&type=script&lang=js&"
export * from "./DepositStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./DepositStatusTag.vue?vue&type=style&index=0&id=d82f3e4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports